/**
 *
 * Badge
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import { Component } from './Badge.styles';

function Badge({ endIcon, icon, ...props }) {
  let { label } = props;

  if (endIcon) {
    label = (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
        {props.label}
        {endIcon}
      </Box>
    );
  }

  return <Component size="small" icon={icon} {...props} label={label} />;
}

Badge.propTypes = {
  endIcon: PropTypes.node,
  icon: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default memo(Badge);
